import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppRoutes from './routes';
import { MenusProvider } from './config/menus.tsx';

function App() {
  return (
    <BrowserRouter>
      <MenusProvider>
        <AppRoutes />
        <ToastContainer position="top-right" autoClose={3000} />
      </MenusProvider>
    </BrowserRouter>
  );
}

export default App;